import type { LayoutProps } from "antd";
import { Layout } from "antd";
import type { FC } from "react";

export type IotLayoutProps = LayoutProps;

export const IotLayout: FC<IotLayoutProps> = (props) => <Layout {...props} />;
